import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppConfigService, initConfig } from './services/app-config.service';



@NgModule({ declarations: [], imports: [CommonModule], providers: [
        AppConfigService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class ConfigsModule {
  static forRoot(configurationUrl: string): ModuleWithProviders<ConfigsModule> {
    return {
      ngModule: ConfigsModule,
      providers: [
        {
          provide: APP_INITIALIZER,
          useFactory: initConfig,
          deps: [AppConfigService, configurationUrl],
          multi: true,
        },
        AppConfigService
      ]
    };
  }
}
